<template>
    <div class="control-group">
    <ul>
        <li style="float: left;"> <span class="btn btn-primary labels" @click="openModalLabel"><i class="fa fa-tag"></i>&nbsp; Add <i class="fa fa-plus"></i></span></li>
        <li v-for="(label,key) in toAppearSelectedLabels" :key="key" class="btn btn-success btn-rounded blue-label-btn white-space-inherit"
            style="margin:4px; border:1px solid transparent; float: left;" :style="{ backgroundColor: label.label_color }"
            :class="{'add-label-large-text-style' : viewPage}"
            @click="openModalLabel">
            {{ label.label_name }}
        </li>
<!--        <li v-for="label in addedLabels" class="btn btn-success btn-rounded blue-label-btn" style="margin:4px; border:1px solid transparent;" :style="{ backgroundColor: label.label_color }"  @click="openModalLabel">-->
<!--            {{ label.label_name }}-->
<!--        </li>-->
    </ul>
    <input type="hidden" name="label_ids"  :value="labelIds">

        <confirmation-popup
            :title="`${titleLabel} Labels`"
            message=""
            id="labels"
            :showConfirmBtn="true"
            :showCreateBtn="true"
            confirm-btn-text="Apply"
            :show-cancel-btn="showCreateLabelBTN"
            cancel-btn-text="Create New Label"
            @on-confirm="applyLabel"
            @on-cancel="createNewLabel"
        >
            <div class="label-form">
                <input type="text" name="label-like" placeholder="Search labels" v-model="searchText" @input="labelSearch" class="form-control"/>
                <div class="label-list" style="overflow: auto; height: 170px; margin-top: 10px;">
                    <table border="0" cellspacing="0" cellpadding="0" style="width: 100%;">
                        <tr v-for="label in filteredLabels" :key="label.id">
                            <td style="width: 30px;">
                                <input type="checkbox" :id="'label_' + label.id" :value="label" @change="checkLabel(label, $event)" :checked="isChecked(label)"/>
                            </td>
                            <td>
                                <label :for="'label_' + label.id">{{ label.label_name }}</label>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </confirmation-popup>

        <confirmation-popup
            title="Create new label"
            message=""
            id="create-label"
            :showConfirmBtn="true"
            :showCancelBtn="false"
            confirm-btn-text="Save"
            @on-confirm="applyNewLabel"
        >
            <div class="form-horizontal">
                <div class="success_message">{{ successMessage }}</div>

                <div class="form-group">
                    <label class="col-md-3">Label title</label>
                    <div class="col-md-9">
                        <input v-model="formData.labelName" type="text" class="form-control">
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-md-3">Label color</label>
                    <div class="col-md-2 color-pick">
                        <chrome-picker v-model="this.formData.color" @input="updateColor" />
                    </div>
                </div>

                <div class="form-group">
                    <label class="col-md-3">Parent Label</label>
                    <div class="col-md-9">
                        <select v-model="formData.parentLabel" class="form-control">
                            <!-- Options for parent label -->
                            <option v-for="label in labels" :value="label.id" v-if="label.parent_id == null || label.parent_id == 0 ">{{ label.label_name }}</option>
                        </select>
                    </div>
                </div>

            </div>
        </confirmation-popup>
    </div>
</template>


<script>



import {getLabels, createLabels, selectedLabelsAction,addLabelsToInquiry,createLabelsForInquiry} from "../api";
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";
import { Chrome } from 'vue-color';

export default {
    name: "addLabels",
    components: {ConfirmationPopup, 'chrome-picker': Chrome,},
    props: {
        bookingId:0,
        bookingLabels:[],
        viewPage:null,
        value: null,
        isInquiry:false,
        inquiryId:0,
        allLabels: null
    },
    data() {
      let labels = [];
      if(this.bookingLabels){
        labels = [...this.bookingLabels]
      }

        return {
            labels : [],
            selectedLabels: this.bookingLabels ?? [],
            toAppearSelectedLabels: labels,
            addedLabels:[],
            searchText: '',
            successMessage: '',
            formData: {
                labelName: '',
                color: '',
                parentLabel: null,
            },
            color: '#ff0000',

        }
    },
    computed: {
        titleLabel(){
            return (this.inquiryId && this.isInquiry) ? 'Inquiry' : 'Booking';
        },
        showCreateLabelBTN(){
            return ( (this.inquiryId && this.isInquiry && this.viewPage)  || this.bookingId ) ? true : false;
        },
        filteredLabels() {
            // Separate the selected and unselected labels
            const selectedLabels = this.labels.filter(label =>
                this.selectedLabels.some(selectedLabel => selectedLabel.id === label.id)
            );

            const unselectedLabels = this.labels.filter(label =>
                !this.selectedLabels.some(selectedLabel => selectedLabel.id === label.id)
            );

            // Combine the selected labels first, followed by unselected labels
            const sortedLabels = selectedLabels.concat(unselectedLabels);

            // Filter based on the search text
            return sortedLabels.filter(label =>
                label.label_name.toLowerCase().includes(this.searchText.toLowerCase())
            );
        },
        labelIds() {
            if (this.selectedLabels.length)
            {
                let ids = this.selectedLabels.map(label => label.id);
                return ids.join(', ');
            }else{
                let ids = null;
                return ids;
            }
        }
    },
    mounted() {
      if(this.allLabels)
        this.labels = this.allLabels
      else {
        getLabels().then((response) => {
          this.labels = response.data;
        });
      }
    },
    methods: {
        openModalLabel(){
            $('#labels').modal('show')
        },
        labelSearch() {
            if (this.searchText.length >= 3) {
                // Implement the search functionality or API call here
            }
        },
        applyLabel() {
            this.toAppearSelectedLabels = [...this.selectedLabels]
            if(this.viewPage){
                if(this.isInquiry && this.inquiryId){
                    addLabelsToInquiry(this.inquiryId, this.labelIds).then((response) => {});
                }else{

                    selectedLabelsAction(this.bookingId, this.labelIds).then((response) => {});
                }
            }
            $('#labels').modal('hide')
        },
        createNewLabel(){
            $('#labels').modal('hide')
            $('#create-label').modal('show')
        },
        applyNewLabel(){
            // alert("mmm");
            let vm = this;
            console.log(vm.selectedLabels)
            if(this.isInquiry && this.inquiryId) {
                createLabelsForInquiry(this.formData,this.inquiryId).then((response) => {
                    vm.selectedLabels.push(response.data);
                    vm.filteredLabels.push(response.data);
                    vm.labels.push(response.data);
                    vm.toAppearSelectedLabels = [...this.selectedLabels];
                });
            }else{
                createLabels(this.formData,this.bookingId).then((response) => {
                    this.selectedLabels.push(response.data.label);
                    this.filteredLabels.push(response.data.label);
                    this.labels.push(response.data.label);
                    this.toAppearSelectedLabels = [...this.selectedLabels];
                });
            }

        },
        updateColor(newColor) {
            this.formData.color = newColor.hex.slice(1);
        },
        checkLabel(selectedLabel, event) {
            const index = this.selectedLabels .findIndex(label => label.id === selectedLabel.id);
            if (index !== -1) {
                // Label is already in selectedLabels, so remove it
                this.selectedLabels .splice(index, 1);
            } else {
                // Label is not in selectedLabels, so add it
                this.selectedLabels.push(selectedLabel);
            }

        },
        isChecked(label) {
            const selectedLabelsIds = this.selectedLabels.map(item => item.id);
            return selectedLabelsIds.includes(label.id);
        }
    },
    watch: {

    }
}
</script>
<style scoped>
    .labels{
        border-radius: 100px;
    }
    @media (max-width: 991px) {
        .white-space-inherit {
            white-space: inherit;
        }
    }

    .add-label-large-text-style{
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>